(() => {
  if (window.JCProductExpressTermsLoaded) return;
  window.JCProductExpressTermsLoaded = true;

  const getTermsBlock = (button) => {
    const actions = button.closest('.jc-product-actions');
    return actions ? actions.querySelector('[data-jc-product-express-terms]') : null;
  };

  const clearError = (block) => {
    if (!block) return;
    block.classList.remove('is-invalid');
    const error = block.querySelector('.jc-product-express-terms__error');
    if (error) error.hidden = true;
  };

  const showError = (block) => {
    if (!block) return;
    block.classList.add('is-invalid');
    const error = block.querySelector('.jc-product-express-terms__error');
    const input = block.querySelector('[data-jc-product-express-terms-input]');
    if (error) error.hidden = false;
    if (input) {
      input.focus({ preventScroll: true });
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-jc-express]');
      if (!button) return;

      const block = getTermsBlock(button);
      if (!block) return;

      const input = block.querySelector('[data-jc-product-express-terms-input]');
      if (input && input.checked) {
        clearError(block);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      showError(block);
    },
    true
  );

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-jc-product-express-terms-input]')) return;
    if (event.target.checked) clearError(event.target.closest('[data-jc-product-express-terms]'));
  });
})();
